const MainLayout = () => import("@/layout/MainLayout");
const BookLayout = () => import("@/layout/BookLayout");

const BookView = () => import("@/views/book/BookView");
const MainView = () => import("@/views/main/MainView");

export default [
  {
    path: "/main",
    component: MainLayout,
    redirect: "/",
    children: [
      {
        path: "",
        name: "MainView",
        component: MainView,
        meta: {
          usePathKey: true,
          title: "学习中心",
        },
      },
    ],
  },
  {
    path: "/book/:id",
    component: BookLayout,
    redirect: "/",
    children: [
      {
        path: "",
        name: "BookView",
        component: BookView,
        meta: {
          usePathKey: true,
          hidden: true,
          title: "图书页面",
        },
      },
    ],
  },
];
